/**
 * Hide star ratings with no reviews on product cards drawn by the USF search app (collection + search pages).
 *
 * USF draws cards in the browser from its own template (assets/usf.js, which the app overwrites, so it can't be
 * edited). That template shows stars whenever a product has a reviews.rating value, even when
 * reviews.rating_count is 0 - after the Fera review groups were split some products kept an old rating with
 * no reviews, which showed stars and "(0)". Same rule as the theme's own cards (snippets/card-product.liquid):
 * no reviews, no stars.
 */
(function () {
  function reviewCount(countEl) {
    var match = (countEl.textContent || '').match(/\((\d+)\)/);
    return match ? Number(match[1]) : 0; // "(undefined)" or no number counts as no reviews
  }

  function clean(root) {
    root.querySelectorAll('.rating-count').forEach(function (countEl) {
      if (reviewCount(countEl) > 0) return;
      var parent = countEl.parentElement;
      if (!parent) return;
      parent.querySelectorAll(':scope > .rating, :scope > .rating-text, :scope > .rating-count').forEach(function (el) {
        if (el.style.display !== 'none') el.style.display = 'none';
      });
    });
  }

  function start() {
    clean(document);
    // USF re-draws the grid on filter, sort and page changes: re-check whatever it adds.
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) { clean(document); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
